const detectFiscalPeriod = (data) => {
  console.log("🚀 ~ detectFiscalPeriod ~ data:", data);
  const month = new Date(data).getMonth() + 1;
  console.log("🚀 ~ detectFiscalPeriod ~ month:", month);

  switch (true) {
    case month < 4:
      return "1";
    case month > 3 && month < 7:
      return "2";
    case month > 6 && month < 10:
      return "3";
    case month > 9 && month <= 12:
      return "4";
    default:
      return "null";
  }
};

export default detectFiscalPeriod;
